import { render } from "./NewsCenterDetail.vue?vue&type=template&id=21978408&scoped=true"
import script from "./NewsCenterDetail.vue?vue&type=script&lang=js"
export * from "./NewsCenterDetail.vue?vue&type=script&lang=js"

import "./NewsCenterDetail.vue?vue&type=style&index=0&id=21978408&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21978408"]])

export default __exports__